//mutations
export const SET_TOKEN = "SET_TOKEN" //token值
export const SET_TOKENTIME = "SET_TOKENTIME" //token有效期
export const SET_TOKEN_EXPRIRES = "SET_TOKEN_EXPRIRES" //token有效时长
export const SET_STEP = "SET_STEP" //保存认证步骤

//我要卖房模块
export const SET_PROPERTY_MSG = "SET_PROPERTY_MSG"  //产权信息输入保存
export const SET_RESPONSE_HOUSEMSG = "SET_RESPONSE_HOUSEMSG" //产权验证返回信息保存
export const SET_FILL_MSG = "SET_FILL_MSG" //用户自行填写的房屋信息保存
export const SET_STEP4_MSG = "SET_STEP4_MSG" //步骤4信息保存

//用户中心
export const SET_LOGINING = "SET_LOGINING" //登录状态
export const SET_USER_INFO = "SET_USER_INFO" //用户信息保存
export const SET_ISVERIFY = "SET_ISVERIFY" //是否认证
export const SET_BUYER = "SET_BUYER" //用户身份

//预约模块
export const SET_APPOINTMENT_MSG = "SET_APPOINTMENT_MSG" //预约信息

//人脸认证
export const SET_FACEBEFORE_ROUTER = "SET_FACEBEFORE_ROUTER" //人脸认证前的路由
export const SET_AGREE_TOKEN = "SET_AGREE_TOKEN" //人脸认证前的路由



// WEBPACK FOOTER //
// ./src/store/type.js